/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Downloads_Downloadssuffix1Inputs */

const id_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduhan`)
};

const ms_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat Turun`)
};

const da_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloads`)
};

const de_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloads`)
};

const en_us2_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloads`)
};

const es_es2_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargas`)
};

const es_mx2_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargas`)
};

const fil_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Download`)
};

const fr_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargements`)
};

const it_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

const hu_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letöltések`)
};

const nl_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloads`)
};

const no_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nedlastinger`)
};

const pl_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobieranie`)
};

const pt_br2_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transferências`)
};

const pt_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarregamentos`)
};

const ro_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descărcări`)
};

const fi_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataukset`)
};

const sv_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nedladdningar`)
};

const vi_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lượt tải`)
};

const tr_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İndirme`)
};

const cs_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stažení`)
};

const bg_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изтегляния`)
};

const ru_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузки`)
};

const uk_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантаження`)
};

const ar_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التنزيلات`)
};

const hi_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डाउनलोड`)
};

const th_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดาวน์โหลด`)
};

const ja_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダウンロード`)
};

const zh_cn2_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载`)
};

const zh_hant1_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下載`)
};

const ko_misc_downloads_downloadssuffix1 = /** @type {(inputs: Misc_Downloads_Downloadssuffix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다운로드`)
};

/**
* | output |
* | --- |
* | "Downloads" |
*
* @param {Misc_Downloads_Downloadssuffix1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_downloads_downloadssuffix1 = /** @type {((inputs?: Misc_Downloads_Downloadssuffix1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Downloads_Downloadssuffix1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_downloads_downloadssuffix1(inputs)
	if (locale === "ms") return ms_misc_downloads_downloadssuffix1(inputs)
	if (locale === "da") return da_misc_downloads_downloadssuffix1(inputs)
	if (locale === "de") return de_misc_downloads_downloadssuffix1(inputs)
	if (locale === "en-US") return en_us2_misc_downloads_downloadssuffix1(inputs)
	if (locale === "es-ES") return es_es2_misc_downloads_downloadssuffix1(inputs)
	if (locale === "es-MX") return es_mx2_misc_downloads_downloadssuffix1(inputs)
	if (locale === "fil") return fil_misc_downloads_downloadssuffix1(inputs)
	if (locale === "fr") return fr_misc_downloads_downloadssuffix1(inputs)
	if (locale === "it") return it_misc_downloads_downloadssuffix1(inputs)
	if (locale === "hu") return hu_misc_downloads_downloadssuffix1(inputs)
	if (locale === "nl") return nl_misc_downloads_downloadssuffix1(inputs)
	if (locale === "no") return no_misc_downloads_downloadssuffix1(inputs)
	if (locale === "pl") return pl_misc_downloads_downloadssuffix1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_downloads_downloadssuffix1(inputs)
	if (locale === "pt") return pt_misc_downloads_downloadssuffix1(inputs)
	if (locale === "ro") return ro_misc_downloads_downloadssuffix1(inputs)
	if (locale === "fi") return fi_misc_downloads_downloadssuffix1(inputs)
	if (locale === "sv") return sv_misc_downloads_downloadssuffix1(inputs)
	if (locale === "vi") return vi_misc_downloads_downloadssuffix1(inputs)
	if (locale === "tr") return tr_misc_downloads_downloadssuffix1(inputs)
	if (locale === "cs") return cs_misc_downloads_downloadssuffix1(inputs)
	if (locale === "bg") return bg_misc_downloads_downloadssuffix1(inputs)
	if (locale === "ru") return ru_misc_downloads_downloadssuffix1(inputs)
	if (locale === "uk") return uk_misc_downloads_downloadssuffix1(inputs)
	if (locale === "ar") return ar_misc_downloads_downloadssuffix1(inputs)
	if (locale === "hi") return hi_misc_downloads_downloadssuffix1(inputs)
	if (locale === "th") return th_misc_downloads_downloadssuffix1(inputs)
	if (locale === "ja") return ja_misc_downloads_downloadssuffix1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_downloads_downloadssuffix1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_downloads_downloadssuffix1(inputs)
	return ko_misc_downloads_downloadssuffix1(inputs)
});
export { misc_downloads_downloadssuffix1 as "misc.downloads.downloadsSuffix" }